export class DisMonthDayEntity{
    id:number;
    monthId:number;
    day:number;

    constructor(){}
}